/* eslint-disable */
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  ChevronRightIcon,
  CubeTransparentIcon,
  AdjustmentsIcon,
  TrashIcon,
} from '@heroicons/react/solid';
// import FolderAddIcon from '@heroicons/react/outline/FolderAddIcon';
import BtnDropdown from 'components/Dropdowns/BtnDropdown';
import ConfigConnector from 'components/Modals/ConfigConnector';
// import MyModellingGrid from 'components/Grids/MyModellingGrid';
import FolderGrid from 'components/Grids/FolderGrid';
//import Heading from 'components/Layout/PageHeading';
import BasicModal from 'components/Modals/BasicModal';
// import ShareModal from 'components/Modals/ShareModal';
import ConfigModel from 'components/Modals/ConfigModel';
import SlideOver from 'components/Modals/SlideOver';
import DeleteModal from 'components/Modals/DeleteModal';
import FolderModal from 'components/Modals/FolderModal';
import MoveAssetModal from 'components/Modals/MoveAssetModal';
import useQuery from 'hooks/useQuery';
import {
  getConnectionAction,
  addNewConnectionAction,
  updateConnectionAction,
  deleteConnectionAction,
  executeConnectionAction,
} from 'redux/actions/connection';
import { getConnectorsInputsAction } from 'redux/actions/connector';
//import { ArrowCircleDownIcon } from '@heroicons/react/solid';
import LogModal from 'components/Modals/LogModal';
// import TableAccordion from 'components/Accordions/TableAccordion';
// redux
import {
  executeModelAction,
  deleteModelAction,
  updateModelAction,
  duplicateModelAction,
} from 'redux/actions/model';
import { addNewPermissionAction /* deletePermissionAction */ } from 'redux/actions/acl';
import {
  allFolderAction,
  addNewFolderAction,
  moveToFolderAction,
  editFolderAction,
  deleteFolderAction,
  getFolderAction,
} from 'redux/actions/folder';
import { addNotification } from 'redux/reducers/notification';
// utils
import { timeToUTC } from 'utils/unitConversion';
import { CleanNullishData } from 'utils/DataCleaner';
import folderFlatten from 'utils/folderFlatten';
import searchFolder from 'utils/searchFolder';
import CreateFolderModal from 'components/Modals/CreateFolderModal';
import ContextMenu from 'components/Dropdowns/ContextMenu';
import { useJune } from 'utils/useJune';
import VersionModal from 'components/Modals/ModelModals/VersionModal';
//import { motion } from 'framer-motion';
import ConnectorGrid from 'components/Grids/ConnectorGrid';
import PrimaryBtn from 'components/Buttons/PrimaryBtn';
import SecondaryBtn from 'components/Buttons/SecondaryBtn';
import ModalHeader from 'components/Layout/ModalHeader';
import OAuthModal from 'components/Modals/OAuthModal';
import ExportGrid from 'components/Grids/ExportGrid';
import SearchInput from 'components/Inputs/SearchInput';
import SimpleMultiselect from 'components/Dropdowns/SimpleMultiselect';
import { env } from '../env';
import {
  getResourceRulesetCollectionAction,
  setResourceRulesetAction,
} from 'redux/actions/ruleset';
import SharingModal from 'components/Modals/SharingModal';
import { getTablesAction, exportTableAction } from 'redux/actions/table';
//import model from 'redux/reducers/model';

export default function Folder() {
  const analytics = useJune('f7aFCim6eVJaVfRf');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { paramFolder } = useParams();

  const {
    folderName,
    folders,
    flatFolders,
  } = useSelector(({ folder }) => ({
    folderName: folder?.current?.name,
    folders: folder.folders,
    flatFolders: folder?.flatFolders,
  }));

  const query = useQuery();
  // const { id } = useParams();
  const connector_id = query.get('connector_id');
  const oAuthToken = query.get('token')
    ? connector_id == 18 || connector_id == 105
      ? query.get('token')
      : window.atob(query.get('token'))
    : null;

  const [downloadModal, setDownloadModal] = useState(false);
  const [downloadConnectionModal, setDownloadConnectionModal] = useState(false);
  const [editDatamodelModal, setEditDatamodelModal] = useState(false);
  const [editConnectionModal, setEditConnectionModal] = useState(false);
  const [activeConnection, setActiveConnection] = useState();
  const [activeObject, setActiveObject] = useState();
  const [activeModel, setActiveModel] = useState({});
  const [openDelete, setDeleteModal] = useState(false);
  const [openDeleteConnection, setDeleteModalConnection] = useState(false);
  const [createFolderModal, setCreateFolderModal] = useState(false);
  const [deleteFolderModal, setDeleteFolderModal] = useState(null);
  const [editFolderModal, setEditFolderModal] = useState(null);
  const [versionModal, setVersionModal] = useState(null);
  const [formInputs, setFormInputs] = useState([]);
  const [token, setToken] = useState(oAuthToken);
  const [connectorId, setConnectorId] = useState(connector_id);
  const [inputMode, setInputMode] = useState('add');
  const [newConfigModal, setNewConfigModal] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [oAuthModal, setOAuthModal] = useState(false);
  const [moveAssetModal, setMoveAssetModal] = useState(null);
  const modelFormState = useRef({});
  const connectorFormState = useRef({});
  const [logModal, setLogModal] = useState(false);
  const [tables, setTables] = useState([]);
  const [sharing, setSharing] = useState(false);
  const [rulesets, setRulesets] = useState([]);
  const [folderId, setFolderId] = useState();
  const [page, setPage] = useState(0)

  const [breadcrumbs, setBreadcrumbs] = useState([])
  const [loading, setLoading] = useState(true)
  const [connections, setConnections] = useState([]);
  const [datamodels, setDatamodels] = useState([]);
  const [subfolders, setSubfolders] = useState([]);

  const [currentFolder, setCurrentFolder] = useState({});

  const { user, databases, connectors, connectorCategories, roles, groups } = useSelector(
    ({ auth, databases, connectors, platform }) => {
      return {
        user: auth.user,
        databases: databases.databases,
        connectors: connectors.connectors,
        connectorCategories: connectors?.connectorCategories,
        roles: platform.roles,
        groups: platform.groups,
      };
    }
  );

  // let tabs = [
  //   { id: '1', value: "all", label: 'All' },
  //   { id: '2', value: "connections", label: 'Connections' },
  //   { id: '3', value: "models", label: 'Models' },
  // ];

  const assetTabs = [
    { id: '1', value: 'Connections', label: 'Connections' },
    { id: '2', value: 'Models', label: 'Models' },
    { id: '3', value: 'Folders', label: 'Folders' },
  ];

  const permissionTab = [
    { id: '1', value: 'Shared', label: 'Shared' },
    { id: '2', value: 'Private', label: 'Private' },
  ];

  const combinedArray = groups.map((group) => {
    const matchingSet = rulesets.find((set) => set?.entity_id === group.id) || null;
    return {
      ...group,
      set: matchingSet,
    };
  });

  const changeRule = (group, role) => {
    if (rulesets.find((set) => set.entity_id == group.id)?.ability_set_id != role) {
      const newRuleset = {
        id: group?.set?.id,
        entity_id: group.id,
        ability_set_id: role,
        new: true,
      };
      setRulesets([...rulesets.filter((set) => set.entity_id != group.id), newRuleset]);
    }
  };

  const submitRules = async () => {
    const newRules = rulesets.filter((set) => set.new);
    if (newRules.length > 0) {
      await dispatch(
        setResourceRulesetAction({
          objectId: activeObject.object.id,
          objectType: activeObject.objectType,
          rules: newRules,
        })
      )
        .unwrap()
        .then(async () => {
          // handle result here
          setSharing(false);
          openFolder(currentFolder.id);
        })
        .catch((e) => {
          // handle error here
          console.log('ERROR HERE', e);
        });
    }
  };

  const trackNewModel = useCallback(() => {
    const company = new URL(env.REACT_APP_API_URL)?.host;
    const identifier = `${user?.id}_${company}`;
    if (analytics)
      analytics.track({
        userId: identifier,
        event: 'Created New Model',
        company: company,
        context: {
          groupId: company,
        },
      });
  }, [analytics]);

  const trackCreateConnector = useCallback(
    (id) => {
      const company = new URL(env.REACT_APP_API_URL)?.host;
      const identifier = `${id}_${company}`;
      if (analytics)
        analytics.track({
          userId: identifier,
          event: 'Create Connector Button',
          company: company,
          context: {
            groupId: company,
          },
        });
    },
    [analytics]
  );

  useEffect(function componentDidMount() {
    setFolderId(paramFolder)
  }, []);

  useEffect(function componentDidMount() {
    if (paramFolder) {
      openFolder(paramFolder)
    }
    else {
      openFolder(0)
    }

  }, [paramFolder]);

  const openFolder = async (folderId, loader = true) => {
    //Get folder
    console.log(folderId)
    if (folderId == '-1') {
      folderId = localStorage.getItem('lastFolder');
    }
    navigate(`/folder/${folderId}`, { replace: true });
    if (loader) {
      setLoading(true)
    }

    localStorage.setItem('lastFolder', folderId);
    const content = await dispatch(getFolderAction(folderId)).unwrap()

    if (content.id.toString() !== localStorage.getItem('lastFolder')) {
      //console.log("no longer relevant")
      return;
    }

    setCurrentFolder(content)
    setConnections(content.connections)
    setDatamodels(content.datamodels)
    setSubfolders(content.children)

    //Set Breadcrumps
    // get models from the folder
    const folder = searchFolder(folders, Number(folderId));
    // if folder is found then reverse the breadcrumbs
    if (folder) {
      // we also remove our null ID folder
      folder.breadcrumbs.pop();
      folder.breadcrumbs = folder.breadcrumbs.reverse();
    }
    setBreadcrumbs(folder?.breadcrumbs || [])
    //
  }

  useEffect(() => {
    handleFilter()
    setLoading(false)
  }, [connections, datamodels, subfolders])

  useEffect(() => {
    if (folderId == '-1') {

      openFolder(localStorage.getItem('lastFolder'));

    } else if (Number(paramFolder)) {
      openFolder(Number(paramFolder));
    } else {
      openFolder(0);
    }
  }, [folderId, folders]);

  function folderLookup(id) {
    return flatFolders.find((item) => item.value === Number(id));
  }

  function deleteModel(model) {
    setActiveModel(model);
    setDeleteModal(true);
  }

  function closeDeleteModel() {
    setActiveModel(null);
    setDeleteModal(false);
  }

  function editModel(modelId) {
    setEditDatamodelModal(true);
    setActiveModel(modelId);
  }

  function closeEditModel() {
    setEditDatamodelModal(false);
    setActiveModel(null);
  }

  function modelVersions(model) {
    setVersionModal(true);
    setActiveModel(model);
  }

  function closeVersionLogs() {
    setVersionModal(false);
    setActiveModel(null);
  }

  const downloadDataHandler = async (object, type, table_name, format) => {
    const id = object.id;
    const data = await dispatch(exportTableAction({ object_id: id, object_type: type, table_name, format })).unwrap();
    const url = window.URL.createObjectURL(new Blob([data], { type: 'text/csv' }));
    window.open(url);
  };

  function downloadData(modelId) {
    setDownloadModal(true);
    setActiveModel(modelId);
  }

  function closeDownloadData() {
    setDownloadModal(false);
    setActiveModel(null);
  }

  const moveAssetHandler = async (data) => {
    try {
      await dispatch(moveToFolderAction(data)).unwrap();
      openFolder(data.folder_id);
    } catch ({ message }) {
      dispatch(addNotification({ icon: 'error', header: 'Error', subheader: message }));
    }
  };

  const getConnectorInputs = async (connectorId) => {
    const inputs = await dispatch(getConnectorsInputsAction(connectorId)).unwrap();
    return inputs.inputs;
  };

  async function editConnection(connection) {

    const fullConnection = await dispatch(getConnectionAction(connection.id)).unwrap();

    setActiveConnection(fullConnection);

    // 1- update selected connectionId
    // 2- load and set connector input fields
    // 3- set form mode to 'edit'
    // 4- show the input dialog
    const inputs = await getConnectorInputs(connection?.connector.id);
    setFormInputs(inputs);
    setInputMode('edit');
    setEditConnectionModal(true);
  }

  function deleteConnection(connection) {
    setActiveConnection(connection);
    setDeleteModalConnection(true);
  }

  const deleteConnectionHandler = async (connection) => {
    await dispatch(deleteConnectionAction(connection.id));
    openFolder(currentFolder.id)
    setActiveConnection(null);
    setDeleteModalConnection(false);
  };

  function connectionLogs(connection) {
    setLogModal(true);
    setActiveConnection(connection);
  }

  function closeConnectionLogs() {
    setLogModal(false);
    setActiveConnection(null);
  }

  async function shareObject(objectType, object) {
    const rules = await dispatch(
      getResourceRulesetCollectionAction({ objectType: objectType, objectId: object.id })
    ).unwrap();
    setRulesets(rules);
    setSharing(true);
    setActiveObject({ objectType, object });
  }


  async function getTablesHandler(object, type) {
    setActiveObject(object);
    setDownloadModal(true);
    const tables = await dispatch(getTablesAction({ object_type: type, object_id: object.id })).unwrap();
    setTables(tables);
  }

  function closeDownloadConnectionData() {
    setDownloadConnectionModal(false);
    setConnectionTables([]);
    setActiveConnection(null);
  }

  const executeConnection = async (connectionId) => {
    await dispatch(executeConnectionAction(connectionId));
    openFolder(currentFolder.id)
  };

  const deleteModelHandler = async (model) => {
    await dispatch(deleteModelAction(model.id));
    openFolder(currentFolder.id)
    closeDeleteModel();
  };

  const duplicateModel = async (model) => {
    const dup = await dispatch(duplicateModelAction(model.id)).unwrap();
    openFolder(currentFolder.id);
    //moveAssetHandler({ asset: 'Datamodel', asset_id: dup.id, folder_id: Number(folderId) });
  };

  const executeModel = async (modelId) => {
    await dispatch(executeModelAction(modelId));
    openFolder(currentFolder.id)
  };

  const configStateCallbackDatamodel = (state) => {
    modelFormState.current = state;
  };

  const configStateCallbackConnection = (state) => {
    connectorFormState.current = state;
  };

  // const saveButtonClickHandler = (e) => {
  //   console.log(e)
  //   e.preventDefault();
  //   //convert schedule time to UTC
  //   modelFormState.current.time = timeToUTC(modelFormState.current.time)
  //   modelSaveHandler(modelFormState.current);
  // };

  const saveButtonClickHandler = (e) => {
    e.preventDefault();
    //convert schedule time to UTC
    modelFormState.current.time = timeToUTC(modelFormState.current.time);
    modelSaveHandler(modelFormState.current);
  };

  const saveButtonClickHandlerConnection = async (e) => {
    e.preventDefault();
    //convert schedule time to UTC
    connectorFormState.current.time = timeToUTC(connectorFormState.current.time);
    return await connectionSaveHandler(connectorFormState.current);
  };

  const modelSaveHandler = async (data = {}) => {
    // clean data before passing to API
    const cleanData = CleanNullishData(data);
    // edit mode connection save
    await dispatch(updateModelAction({ data: cleanData, modelId: activeModel.id }));
    // close the slider and reset values
    closeEditModel();
    // hide connection input dialog upon successful connection
    // setConnectionInputDialog(false);
    // refresh connections table to show new entry
    await dispatch(allFolderAction());
  };

  function closeEditConnection() {
    setEditConnectionModal(false);
    setActiveConnection(null);
    setFormInputs([]);
  }

  const connectHandler = async (connector) => {
    setActiveConnection(connector);

    if (connector?.oauth_url) {
      setOAuthModal(true);
    } else {
      // history.push(`/app/connectors/${connector?.id}`);
      // 1- load and set connector input fields
      // 2- set form mode to 'add'
      // 3- show the input dialog
      const inputs = await getConnectorInputs(connector?.id);
      setFormInputs(inputs);
      setInputMode('add');
      setNewConfigModal(true);
    }
  };

  // effect runs on connector callback mode
  useEffect(() => {
    async function OAuthCallback() {
      if (connectorId && connectors?.length) {
        const inputs = await getConnectorInputs(Number(connectorId));
        const connector = connectors.find((item) => item.id === Number(connectorId));
        setActiveConnection(connector);
        setFormInputs(inputs);
        setNewConfigModal(true);
      }
    }
    OAuthCallback();
  }, [connectorId, connectors]);

  const connectionSaveHandler = async (data = {}) => {
    // clean data before passing to API
    const cleanData = CleanNullishData(data);
    cleanData['connectorId'] = cleanData?.connection_id;
    // new mode connection save
    if (inputMode === 'add') {
      await dispatch(addNewConnectionAction({ data: cleanData }));
      // token cleanup
      setToken(null);
      setConnectorId(null);
      // close the new connection modals
      setNewConfigModal(false);
      setCreateModal(false);
      // get rid of the connector id in the url for e.g /connectors/13
      if (folderId) {
        navigate(`/folder/${folderId}`, { replace: true });
      } else {
        navigate(`/folder`, { replace: true });
      }
    } else {
      // edit mode connection save
      await dispatch(
        updateConnectionAction({ data: cleanData, connectionId: cleanData?.connection_id })
      );
      // close the slider and reset values
      closeEditConnection();
    }

    // hide connection input dialog upon successful connection
    // setConnectionInputDialog(false);
    // refresh connections table to show new entry
    openFolder(currentFolder.id)
  };

  const addPermissionHandler = async (modelId) => {
    await dispatch(addNewPermissionAction({ assetId: modelId, data: { asset: 'Datamodel' } }));
    openFolder(currentFolder.id)
  };
  /* const removePermissionHandler = async (modelId) => {
    await dispatch(deletePermissionAction(modelId));
    dispatch(allFolderAction());
  }; */

  const editFolder = async (folder) => {
    await dispatch(
      editFolderAction({ name: folder.name, folderId: folder.id, parent_id: folder.parent_id })
    );
    // openFolder is synced better when done before reloading all folders
    await dispatch(allFolderAction())
    openFolder(folder.parent_id || folder.id);

  };

  const deleteFolder = async (folder) => {
    await dispatch(deleteFolderAction(folder.id));
    openFolder(folder.parent_id);
  };

  const createFolder = async (name) => {
    await dispatch(addNewFolderAction({ name, parent_id: currentFolder.id }));
    await dispatch(allFolderAction())
    openFolder(currentFolder.id)
  };

  useEffect(() => {
    const interval = setInterval(async () => {
      openFolder(currentFolder.id, false)
    }, 30000);
    return () => clearInterval(interval);
  }, [currentFolder]);

  const folderItems = useCallback(
    (id) => {
      const folderItems = folderFlatten(folders, id);
      return folderItems;
    },
    [folders]
  );

  const folderOptions = [
    {
      id: 'renameFolder',
      text: 'Edit Folder',
      logo: <AdjustmentsIcon className="mr-2 h-4 w-4" aria-hidden="true" />,
      ability: 'folder-manage',
      action: (folder) => {
        const parent = folderLookup(folder.parent_id);
        setEditFolderModal({ ...folder, parent });

      },
    },
    {
      id: 'deleteFolder',
      text: 'Delete Folder',
      logo: <TrashIcon className="mr-2 h-4 w-4" aria-hidden="true" />,
      ability: 'folder-delete',
      classes: 'hover:!text-red-500 hover:!bg-red-100',
      action: (folder) => {
        setDeleteFolderModal(folder);
      },
    },
  ];

  const canCreate = (permission) => {

    //Check if the user has the ability to create a new object
    if (!user?.abilities?.includes(permission)) {
      return false
    }

    //If root then return true
    if (currentFolder?.id == 0) {
      return true
    }

    //If the user is the owner of the folder then return true
    if (currentFolder?.user_id == user?.id) {
      return true
    }


    //If the user is the owner of the folder then return true
    if (currentFolder?.abilities?.includes('folder-edit')) {
      return true
    }

    return false

  }

  const createBtnItems = [
    {
      header: 'New Connection',
      valid: true,
      ability: canCreate("connection-create"),
      icon: (
        <svg
          className="mr-2 h-5 w-5 text-zinc-400 group-hover:text-zinc-500 dark:text-zinc-300 dark:group-hover:text-zinc-200"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.6776 11.9176L7.14842 11.3861L7.14842 11.3861L7.6776 11.9176ZM8.85024 10.75L9.37942 10.2185C9.08679 9.92716 8.6137 9.92716 8.32107 10.2185L8.85024 10.75ZM13.287 15.1676L13.8162 15.6991C13.9576 15.5583 14.037 15.3671 14.037 15.1676C14.037 14.9681 13.9576 14.7768 13.8162 14.6361L13.287 15.1676ZM12.1144 16.3351L11.5852 15.8036L11.5852 15.8036L12.1144 16.3351ZM4.22082 18.7185C3.92729 19.0108 3.92626 19.4856 4.21852 19.7792C4.51077 20.0727 4.98565 20.0737 5.27918 19.7815L4.22082 18.7185ZM9.53511 11.4273C9.24158 11.7196 9.24055 12.1944 9.5328 12.488C9.82506 12.7815 10.2999 12.7825 10.5935 12.4903L9.53511 11.4273ZM12.8119 10.2815C13.1054 9.98923 13.1064 9.51435 12.8142 9.22082C12.5219 8.9273 12.047 8.92626 11.7535 9.21852L12.8119 10.2815ZM11.5438 13.4273C11.2503 13.7196 11.2493 14.1944 11.5415 14.488C11.8338 14.7815 12.3086 14.7825 12.6022 14.4903L11.5438 13.4273ZM14.7792 12.3227C15.0727 12.0304 15.0737 11.5556 14.7815 11.262C14.4892 10.9685 14.0144 10.9675 13.7208 11.2597L14.7792 12.3227ZM18.3224 5.6649L18.8516 5.13342L18.3224 5.6649ZM18.3224 10.0824L17.7932 9.55096L17.7932 9.55096L18.3224 10.0824ZM17.1498 11.25L16.6206 11.7815C16.9132 12.0728 17.3863 12.0728 17.6789 11.7815L17.1498 11.25ZM12.713 6.83243L12.1838 6.30093C12.0424 6.44167 11.963 6.63294 11.963 6.83242C11.963 7.0319 12.0424 7.22316 12.1838 7.36391L12.713 6.83243ZM13.8856 5.6649L14.4148 6.1964L14.4148 6.19638L13.8856 5.6649ZM8.20678 15.8036C7.27603 14.8769 7.27603 13.3758 8.20678 12.449L7.14842 11.3861C5.62881 12.8991 5.62881 15.3536 7.14842 16.8666L8.20678 15.8036ZM8.20678 12.449L9.37942 11.2815L8.32107 10.2185L7.14842 11.3861L8.20678 12.449ZM11.5852 15.8036C10.6526 16.7321 9.13933 16.7321 8.20678 15.8036L7.14842 16.8666C8.66623 18.3778 11.1257 18.3778 12.6435 16.8666L11.5852 15.8036ZM12.7579 14.6361L11.5852 15.8036L12.6435 16.8666L13.8162 15.6991L12.7579 14.6361ZM7.14842 15.8036L4.22082 18.7185L5.27918 19.7815L8.20678 16.8666L7.14842 15.8036ZM8.32107 11.2815L12.7579 15.6991L13.8162 14.6361L9.37942 10.2185L8.32107 11.2815ZM10.5935 12.4903L12.8119 10.2815L11.7535 9.21852L9.53511 11.4273L10.5935 12.4903ZM12.6022 14.4903L14.7792 12.3227L13.7208 11.2597L11.5438 13.4273L12.6022 14.4903ZM17.7932 6.19638C18.724 7.1231 18.724 8.62424 17.7932 9.55096L18.8516 10.6139C20.3712 9.10089 20.3712 6.64644 18.8516 5.13342L17.7932 6.19638ZM17.7932 9.55096L16.6206 10.7185L17.6789 11.7815L18.8516 10.6139L17.7932 9.55096ZM14.4148 6.19638C15.3474 5.26787 16.8607 5.26787 17.7932 6.19638L18.8516 5.13342C17.3338 3.62219 14.8743 3.62219 13.3565 5.13342L14.4148 6.19638ZM13.2421 7.36393L14.4148 6.1964L13.3565 5.1334L12.1838 6.30093L13.2421 7.36393ZM17.6789 10.7185L13.2421 6.30095L12.1838 7.36391L16.6206 11.7815L17.6789 10.7185Z"
            fill="currentColor"
          />
        </svg>
      ),
      action: () => {
        trackCreateConnector(user.user?.id);
        setCreateModal(true);
      },
    },
    {
      header: 'New Model',
      valid: true,
      ability: canCreate("datamodel-create"),
      icon: (
        <CubeTransparentIcon
          className="mr-2 h-4 w-4 text-zinc-400 group-hover:text-zinc-500 dark:text-zinc-300 dark:group-hover:text-zinc-200"
          aria-hidden="true"
        />
      ),
      action: () => {
        trackNewModel(), navigate(`/modelling/edit/new`);
      },
    },
    {
      header: 'New Folder',
      valid: currentFolder?.id != -1,
      ability: canCreate("folder-create"),
      icon: (
        <svg
          className="mr-2 h-5 w-5 text-zinc-400 group-hover:text-zinc-500 dark:text-zinc-300 dark:group-hover:text-zinc-200"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M12.25 19.25H6.75C5.64543 19.25 4.75 18.3546 4.75 17.25V7.75H17.25C18.3546 7.75 19.25 8.64543 19.25 9.75V12.25"
          />
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M13.5 7.5L12.5685 5.7923C12.2181 5.14977 11.5446 4.75 10.8127 4.75H6.75C5.64543 4.75 4.75 5.64543 4.75 6.75V11"
          />
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M17 14.75V19.25"
          />
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M19.25 17L14.75 17"
          />
        </svg>
      ),
      action: () => {
        setCreateFolderModal(true);
      },
    },
  ];

  // const navbar = document.getElementById('nav-bar')?.offsetWidth;
  // console.log(navbar);

  // const styling = {
  //   left: navbar,
  //   width: `calc(100vw - ${navbar}px)`,
  // };

  const [navbarWidth, setNavbarWidth] = useState(0);

  useEffect(() => {
    const updateNavbarWidth = () => {
      const navbarElement = document.getElementById('nav-bar');
      if (navbarElement) {
        const width = navbarElement.offsetWidth;
        setNavbarWidth(width);
      }
    };

    // Update the width initially and add event listener
    updateNavbarWidth();
    const interval = setInterval(updateNavbarWidth, 10); // Check every 100 milliseconds

    // Clean up the event listener and interval when the component unmounts
    return () => {
      clearInterval(interval);
    };
  }, []);

  // const filtered = filterObjects.filter((table) => {
  //     const { table_name, source_name, source_type } = table;
  //     const lowerCaseSearch = filterSearch.toLowerCase();

  //     return (
  //       table_name.toLowerCase().includes(lowerCaseSearch) ||
  //       source_name.toLowerCase().includes(lowerCaseSearch) ||
  //       source_type.toLowerCase().includes(lowerCaseSearch)
  //     );
  //   });
  //   setFilteredTables(filtered);
  // };

  const styling = {
    left: navbarWidth,
    width: `calc(100vw - ${navbarWidth}px)`,
  };

  const [selectedIndices, setSelectedIndex] = useState(localStorage.getItem('selectedIndices') ? JSON.parse(localStorage.getItem('selectedIndices')) : { "Connections": true, "Models": true, "Folders": true });
  const [permissionShow, setPermissionShow] = useState(localStorage.getItem('permissionShow') ? JSON.parse(localStorage.getItem('permissionShow')) : { "Shared": true, "Private": true });
  const [filterSearch, setFilterSearch] = useState('');
  const [filteredConnections, setFilteredConnections] = useState(connections);
  const [filteredModels, setFilteredModels] = useState(datamodels);
  const [filteredSubfolders, setFilteredSubfolders] = useState(subfolders);
  const [filteredObjectCount, setFilteredObjectCount] = useState(0);


  useEffect(() => {

    localStorage.setItem('selectedIndices', JSON.stringify(selectedIndices));
    localStorage.setItem('permissionShow', JSON.stringify(permissionShow));

  }, [selectedIndices, permissionShow]);

  const handleFilter = () => {
    const filtered1 = connections.filter((item) =>
      item.name.toLowerCase().includes(filterSearch.toLowerCase())
    );
    setFilteredConnections(filtered1);

    const filtered2 = datamodels.filter((item) =>
      item.name.toLowerCase().includes(filterSearch.toLowerCase())
    );
    setFilteredModels(filtered2);

    const filtered3 = subfolders.filter((item) =>
      item.name.toLowerCase().includes(filterSearch.toLowerCase())
    );
    setFilteredSubfolders(filtered3);
  };

  useEffect(handleFilter, [filterSearch]);

  const handleSearch = (searchValue) => {
    const newSearchValue = searchValue;
    setFilterSearch(newSearchValue);
  };

  return (
    <div className="overscroll-none h-auto w-auto mx-auto m-3 rounded-lg p-3">
      <div
        key={'folder'}
        style={styling}
        className="absolute h-9  top-0 border-b border-zinc-200 dark:border-zinc-600 flex flex-row items-center justify-between"
      >
        <div className=" text-zinc-500 dark:text-zinc-200 tracking-wide px-11 py-2 text-xs flex flex-row items-center ">
          {breadcrumbs.length > 0 ? (
            <a
              className="hover:text-zinc-700 dark:hover:text-zinc-50 hover:underline underline-offset-4	cursor-pointer transition-all duration-150"
              onClick={() => {
                openFolder(0);
              }}
            >
              Workspace root
            </a>
          ) : (
            <p className="">Workspace root</p>
          )}

          {breadcrumbs.length > 0 && <ChevronRightIcon className="mx-1 h-4 w-4" />}
          {breadcrumbs?.map((crumb, index) => {
            const text =
              breadcrumbs?.length != index + 1 ? (
                <div className="flex flex-row justify-center items-center">
                  <a
                    className="hover:text-zinc-700 dark:hover:text-zinc-50 hover:underline underline-offset-4	cursor-pointer transition-all duration-150"
                    onClick={() => {
                      openFolder(crumb.id);
                    }}
                  >
                    {crumb.name}
                  </a>
                  <ChevronRightIcon className="mx-1 h-4 w-4" />
                </div>
              ) : (
                <>
                  <p>{crumb.name}</p>
                </>
              );
            return (
              <>
                <p>{text}</p>
              </>
            );
          })}
        </div>
        <div className="mr-11">{folderId > 0 && <ContextMenu options={folderOptions} object={currentFolder} />}</div>
      </div>
      <div className="mt-8">
        {/* <div className="flex space-x-1 bg-zinc-100 dark:bg-zinc-700 border border-zinc-300 dark:border-zinc-500 p-1 rounded-3xl w-fit">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`${activeTab === tab.id
                ? 'text-zinc-50 dark:text-zinc-900'
                : 'hover:text-zinc-700/60 dark:text-zinc-200 dark:hover:text-zinc-50/60'
                } relative rounded-full px-3 py-1.5 text-xs font-medium  transition z-20 `}
            >
              {activeTab === tab.id && (
                <motion.span
                  layoutId="bubble3"
                  className="absolute rounded-2xl inset-0 -z-10 bg-zinc-600 dark:bg-zinc-200"
                  //style={{ borderRadius: 9999 }}
                  transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
                />
              )}
              {tab.label}
            </button>
          ))}
        </div> */}
        {/* <div className="mb-5">
          <Heading
            header={`${folderName === '/' ? 'test' : folderName}`}
            button={
              <BtnDropdown btnHeader="Create" items={createBtnItems.filter((item) => item.valid)} />
            }
          />
        </div> */}
        <div className="h-min mt-1 flex flex-row justify-between items-center">
          <div className="w-fit flex flex-row gap-5">
            <SearchInput placeholder="Search..." onChange={handleSearch} />
            <SimpleMultiselect
              placeholder={'Show'}
              items={assetTabs}
              onChange={(val) => setSelectedIndex(val)}
              defaulValue={selectedIndices}
            />
            <SimpleMultiselect
              placeholder={'Show'}
              items={permissionTab}
              onChange={(val) => setPermissionShow(val)}
              defaulValue={permissionShow}
            />
          </div>

          <BtnDropdown btnHeader="Create" items={createBtnItems.filter((item) => item.valid)} />
        </div>
        <p className="ml-px mb-5 mt-3 text-zinc-500 sm:text-xs ">
          Filter: <span className="font-medium text-zinc-600">{filteredObjectCount}</span> out of{' '}
          <span className="font-medium text-zinc-600">
            {connections.length + datamodels.length + subfolders.length}
          </span>{' '}
          assets
        </p>
        <div className="mb-5 relative flex-1 flex flex-row">
          <div className="absolute opacity-60 h-[1px] w-full bg-gradient-to-tr from-[#5DA6FC] via-[#FFC6BA] to-[#ff5478]"></div>
          <div className="relative bg-white sm:flex sm:items-center sm:justify-between"></div>
        </div>
        {!loading && (
          <FolderGrid
            {...{
              permissionShow: permissionShow,
              getTablesHandler,
              setFilteredObjectCount: setFilteredObjectCount,
              activeTab: selectedIndices,
              models: filteredModels,
              connections: filteredConnections,
              editConnection,
              executeConnection,
              deleteConnection,
              connectionLogs,
              subfolders: filteredSubfolders,
              executeModel,
              downloadData,
              editModel,
              deleteModel,
              modelVersions,
              duplicateModel,
              addPermissionHandler,
              emptyMessage: 'No assets',
              moveFolderHandler: setMoveAssetModal,
              openFolder,
              page,
              setPage,
              refreshFolders: () => {
                openFolder(currentFolder.id)
              },
              editFolder: (folder) => {
                const parent = folderLookup(folder.parent_id);
                setEditFolderModal({ ...folder, parent });
              },
              deleteFolder: (folder) => {
                setDeleteFolderModal(folder);
              },
              shareObject: shareObject,
            }}
          />
        )}

        {loading && (

          <div role="status" className="p-4 space-y-4 border border-gray-200 divide-y divide-gray-200 rounded shadow animate-pulse dark:divide-gray-700 md:p-6 dark:border-gray-700">
            <div className="flex items-center justify-between">
              <div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
            </div>
            <div className="flex items-center justify-between pt-4">
              <div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
            </div>
            <div className="flex items-center justify-between pt-4">
              <div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
            </div>
            <div className="flex items-center justify-between pt-4">
              <div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
            </div>
            <div className="flex items-center justify-between pt-4">
              <div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
            </div>
            <span className="sr-only">Loading...</span>
          </div>

        )}
        {/* <TableAccordion header="Private" description="| Only visible to you">
        <MyModellingGrid
          {...{
            models: myModels,
            executeModel,
            downloadData,
            editModel,
            deleteModel,
            duplicateModel,
            addPermissionHandler,
            emptyMessage: 'No private models',
          }}
        />
      </TableAccordion>
      <TableAccordion header="Team" description="| Visible to your team">
        <MyModellingGrid
          {...{
            models: sharedModels,
            executeModel,
            downloadData,
            editModel,
            deleteModel,
            duplicateModel,
            removePermissionHandler,
            emptyMessage: 'No team models',
          }}
        />
      </TableAccordion> */}

        {downloadModal && (
          <BasicModal
            open={downloadModal}
            onClose={() => closeDownloadData()}
            classes={'max-w-[500px]'}
            content={
              <ExportGrid
                object={activeObject}
                tables={tables}
                downloadData={downloadDataHandler}
              />
            }
          />
        )}
        {openDelete && (
          <DeleteModal
            open={openDelete}
            onClose={() => closeDeleteModel()}
            header="Delete Model"
            description="Are you sure you want to delete this model? The model will be permanently removed. This action cannot be undone."
            deletetxt="Delete model"
            deletepress={() => deleteModelHandler(activeModel)}
          />
        )}

        {/* <ShareModal
          open={true}
          onClose={() => closeDeleteModel()}
          header="Share"
          description="You can share this"
          sharetxt="Share"
          shareclick={() => console.log("SHARING THE MODEL")}
        /> */}
        {editDatamodelModal && (
          <SlideOver
            open={editDatamodelModal}
            title="Edit Model"
            onClose={() => setEditDatamodelModal(false)}
            submitHandler={saveButtonClickHandler}
          >
            <div className="px-5">
              <ConfigModel
                model={{ ...activeModel }}
                stateChangeCallback={configStateCallbackDatamodel}
              />
            </div>
          </SlideOver>
        )}
        {editConnectionModal && (
          <SlideOver
            classes={`${activeConnection.name == 'Python' ? '!max-w-4xl' : ''}`}
            open
            title="Edit Connector"
            subtitle={
              <p className="max-w-4xl leading-relaxed	text-sm align-baseline text-zinc-500 dark:text-zinc-200">
                We have{' '}
                <a
                  href="https://resources.less.tech/less-tech/connectors/connector-guides"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm underline decoration-2 decoration-[#5DA6FC]
                                  underline-offset-[3px] text-zinc-500 dark:text-zinc-200 font-medium "
                >
                  guides
                </a>{' '}
                all the Connectors. If you need additional help, feel free to{' '}
                <a
                  href="https://calendly.com/thomas-less/speak-to-less"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm underline decoration-2 decoration-[#ff5478]
                                  underline-offset-[3px] text-zinc-500 dark:text-zinc-200 font-medium "
                >
                  schedule a call
                </a>{' '}
                with us
              </p>
            }
            onClose={() => setEditConnectionModal()}
            submitHandler={saveButtonClickHandlerConnection}
          >
            <div className="px-5">
              {activeConnection && (
                <ConfigConnector
                  {...{
                    connection: activeConnection,
                    connector: activeConnection?.connector,
                    databases,
                    inputs: formInputs,
                    stateChangeCallback: configStateCallbackConnection,
                    token,
                  }}
                />
              )}
            </div>
          </SlideOver>
        )}
        {downloadConnectionModal && (
          <BasicModal
            open
            classes="w-[600px] 2xl:w-[700px] min-w-lg"
            onClose={() => closeDownloadConnectionData()}
            content={
              <ConnectionExportGrid
                tables={connectionTables}
                downloadData={downloadConnectionData}
              />
            }
          />
        )}
        {openDeleteConnection && (
          <DeleteModal
            open
            onClose={() => setDeleteModalConnection(false)}
            header="Delete Connection"
            description="Are you sure you want to delete this Connection? The Connection will be permanently removed. This action cannot be undone."
            deletetxt="Delete Connection"
            deletepress={() => deleteConnectionHandler(activeConnection)}
          />
        )}
        {logModal && (
          <BasicModal
            open
            classes="w-[90vw] h-[90vh] min-w-lg"
            onClose={() => closeConnectionLogs()}
            content={
              <LogModal
                activeConnection={activeConnection}
                header="{ConnectionName}"
                onClose={() => closeConnectionLogs()}
              />
            }
          />
        )}

        {createModal && (
          <BasicModal
            open
            classes="w-[1200px] 2xl:w-[1400px]"
            onClose={() => setCreateModal(false)}
            content={<ConnectorGrid {...{ connectors, connectorCategories, connectHandler }} />}
          />
        )}
        {oAuthModal && (
          <BasicModal
            open
            classes="w-[400px] 2xl:w-[500px] min-w-lg "
            onClose={() => setOAuthModal(false)}
            content={
              <OAuthModal
                title={activeConnection?.name}
                oauth_url={activeConnection?.oauth_url}
                icon={
                  <img
                    className="object-center align-middle justify-center content-center"
                    src={activeConnection?.logo}
                    alt={activeConnection?.name}
                  />
                }
              />
            }
          />
        )}
        {newConfigModal && (
          <BasicModal
            open
            classes={`${activeConnection.name == 'Python'
              ? 'w-[900px] 2xl:w-[1000px]'
              : 'w-[600px] 2xl:w-[700px]'
              }  min-w-lg`}
            content={
              <>
                <div className="p-8 overflow-visible">
                  <ModalHeader
                    header={activeConnection?.name}
                    content={
                      <p dangerouslySetInnerHTML={{ __html: activeConnection?.help_text }} />
                    }
                  />

                  <ConfigConnector
                    {...{
                      connector: activeConnection, // activeConnection is actually a connector here
                      databases,
                      inputs: formInputs,
                      stateChangeCallback: configStateCallbackConnection,
                      token,
                    }}
                  />
                </div>
                {/* Action buttons */}
                <div className="w-full bg-zinc-100 dark:bg-zinc-900 z-50  bottom-0 sticky border-t border-zinc-200 dark:border-zinc-600 px-4 py-5 sm:px-6">
                  <div className="flex justify-end space-x-3">
                    <SecondaryBtn text="Cancel" onClick={() => setNewConfigModal(false)} />
                    <PrimaryBtn
                      text="Save Changes"
                      onClick={saveButtonClickHandlerConnection}
                      useEnter={true}
                      loader={true}
                    />
                  </div>
                </div>
              </>
            }
          />
        )}
        {versionModal && (
          <SlideOver
            open
            classes={'!max-w-3xl'}
            actionbtn={false}
            subtitle={
              <p>
                <span className="font-medium">{activeModel.name}</span> owned by{' '}
                <span className="font-medium">{activeModel.user.name}</span>
              </p>
            }
            title="Model Logs and Versions"
            onClose={() => closeVersionLogs()}
          >
            <VersionModal activeModel={activeModel} />
          </SlideOver>
        )}
        {deleteFolderModal && (
          <DeleteModal
            open={!!deleteFolderModal}
            onClose={() => setDeleteFolderModal(null)}
            header="Delete Folder"
            description="Are you sure you want to delete your folder? You will be deleting all assets within the folder as well. This action cannot be undone."
            deletetxt="Delete Folder"
            deletepress={() => deleteFolder(deleteFolderModal)}
          />
        )}
        {createFolderModal && (
          <BasicModal
            open={createFolderModal}
            onClose={() => setCreateFolderModal(false)}
            classes={'w-[500px]'}
            content={
              <CreateFolderModal
                onSubmit={createFolder}
                onClose={() => setCreateFolderModal(false)}
                parentFolder={{ id: folderId, name: folderName }}
                heading="Create New Folder"
                buttonText="Create"
              />
            }
          />
        )}
        {editFolderModal && (
          <BasicModal
            open={!!editFolderModal}
            onClose={() => setEditFolderModal()}
            classes={'w-[500px] !overflow-visible'}
            content={
              <FolderModal
                onClose={() => setEditFolderModal()}
                onSubmit={editFolder}
                folders={folderItems(editFolderModal.id)}
                activFolder={editFolderModal}
                parentFolder={editFolderModal?.parent}
                heading="Update Folder"
                buttonText="Update"
              />
            }
          />
        )}
        {moveAssetModal && (
          <BasicModal
            open={!!moveAssetModal}
            onClose={() => setMoveAssetModal(null)}
            classes={'w-[500px] !overflow-visible'}
            content={
              <MoveAssetModal
                folders={folderItems()}
                onSubmit={(value) => moveAssetHandler({ ...moveAssetModal, folder_id: value })}
                asset={moveAssetModal}
                activeFolder={folderId ? { id: folderId, name: folderName } : { id: 0, name: 'Workspace root' }}
                onClose={() => setMoveAssetModal(null)}
              />
            }
          />
        )}
        {sharing && (
          <SharingModal
            sharing={sharing}
            setSharing={setSharing}
            activeObject={activeObject}
            roles={roles}
            combinedArray={combinedArray}
            submitRules={submitRules}
            changeRule={changeRule}
          />
        )}
      </div>
    </div>
  );
}
